import CreateEditRFID from './CreateEditRFID.vue';
export default CreateEditRFID;
